export default __webpack_public_path__ + "static/DoubleXL-8476e1bd3671ba0221eeba3fb09fce13.svg";